module.exports = __webpack_public_path__ + "static/media/loading.d887ce80.png";